import { makeStyles, darken } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
import { MODE } from './const';

export default makeStyles((theme) => ({
  root: {
    [`&[data-mode="${MODE.warning}"]`]: {
      '& $buttonConfirm': {
        color: theme.palette.getContrastText(COLORS.error.active),
        backgroundColor: COLORS.error.active,
        '&:hover': {
          backgroundColor: darken(COLORS.error.active, 0.2),
        },
      },
    },
  },

  paper: {
    minWidth: 400,
    maxWidth: 600,
    borderRadius: theme.shape.borderRadiusLarge,
  },
  dialogTitle: {
    padding: theme.spacing(2.5),
    whiteSpace: 'pre-wrap',
  },
  dialogContent: {
    padding: theme.spacing(3, 3, 5, 3),
  },
  dialogActions: {
    margin: theme.spacing(0),
    padding: theme.spacing(2.5, 5),
    justifyContent: 'end',
  },
  title: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightBold,
    color: COLORS.neutral.blackBlue,
    textAlign: 'start',
  },
  content: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(24),
    color: COLORS.neutral.secondary,
    whiteSpace: 'pre-wrap',
    textAlign: 'start',
  },
  buttonConfirm: {
    fontSize: theme.typography.pxToRem(16),
  },
  buttonCancel: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(16),
  },
}));
